import React, { Component, Fragment } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import routesEducacao from '../../routes/routerEducacao';
import routesSTI from '../../routes/routerSTI';
import routesProducaoEP from '../../routes/routerProducaoEP';
import routesProducaoSTI from '../../routes/routerProducaoSTI';
import routesAdmin from '../../routes/routerAdmin';
import Sidebar from '../../Components/UI/Sidebar';
import Header from '../../Components/UI/Header';
import Footer from '../../Components/UI/Footer';


export default class PagePrincipal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Principal"
        }
    }

    render() {
        return (
            <Fragment>
                <div className="main-panel min-vh-100">
                    <BrowserRouter>
                        <Switch>
                            {routesEducacao}
                            {routesProducaoSTI}
                            {routesSTI}
                            {routesProducaoEP}
                            {routesAdmin}
                        </Switch>
                    </BrowserRouter>
                    <Footer />
                </div>
                <Header />
                <Sidebar />
            </Fragment>
        )
    }
}